<div class="content cron-dashboard">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Cron Jobs</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item">Super Admin</li>
          <li class="breadcrumb-item active" aria-current="page">Cron Jobs</li>
        </ol>
      </nav>
    </div>
    <div class="ms-2">
      <button class="btn btn-primary d-flex align-items-center" (click)="openScheduleModal()">
        <i class="ti ti-circle-plus me-2"></i>Add Schedule
      </button>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="row">
    <div class="card">
      <!-- <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Cron Schedule List</h5>

          <button
            type="button"
            class="btn btn-primary d-flex align-items-center"
            (click)="openScheduleModal()"
          >
            <i class="ti ti-circle-plus me-2"></i>
            Add Schedule
          </button>
        </div> -->

      <div class="card-body p-0">
        <div class="custom-datatable-filter table-responsive">
          <table class="table datatable">
            <thead class="thead-light">
              <tr>
                <th>Cron</th>
                <th>Schedule</th>
                <th>Run Time</th>
                <th>Business</th>
                <th>Status</th>
                <th>Last Run</th>
                <th>Next Run</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let schedule of cronSchedules">
                <td>
                  {{ getCronLabel(schedule.cronName) }}
                </td>

                <td>
                  {{ schedule.scheduleType | capitalize }}
                </td>

                <td>
                  {{ schedule.runTime }}
                </td>

                <td>
                  {{ schedule.businessName || 'All Businesses' }}
                </td>

                <td>
                  <span [ngClass]="schedule.isActive ? 'badge bg-success' : 'badge bg-secondary'">
                    {{ schedule.isActive ? 'Active' : 'Inactive' }}
                  </span>
                </td>

                <td>
                  {{ schedule.lastRun ? (schedule.lastRun | date: 'dd MMM yyyy, hh:mm a') : '-' }}
                </td>

                <td>
                  {{ schedule.nextRun ? (schedule.nextRun | date: 'dd MMM yyyy, hh:mm a') : '-' }}
                </td>

                <td>
                  <a
                    [routerLink]="['/cron/admin/history', schedule.id]"
                    class="employee-avatar me-2"
                    ><i class="ti ti-eye"></i
                  ></a>
                  <a
                    href="javascript:void(0);"
                    class="me-2"
                    (click)="editSchedule(schedule)"
                    title="Edit"
                  >
                    <i class="ti ti-edit"></i>
                  </a>

                  <!-- <button
                      type="button"
                      class="btn btn-sm btn-light"
                      (click)="toggleSchedule(schedule)"
                      [title]="schedule.isActive ? 'Disable' : 'Enable'"
                    >
                      <i
                        class="ti"
                        [ngClass]="schedule.isActive ? 'ti-player-pause' : 'ti-player-play'"
                      ></i>
                    </button> -->

                  <!-- <button type="button" class="btn btn-sm btn-light" title="View Execution History">
                    <i class="ti ti-eye"></i>
                  </button> -->
                </td>
              </tr>

              <tr *ngIf="!scheduleLoading && cronSchedules.length === 0">
                <td colspan="8" class="empty-row">No cron schedules found</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- </div>
    </div>
  </div>
</div> -->

<!-- Cron Schedule Modal -->
<div
  class="modal-overlay"
  *ngIf="showScheduleModal"
  role="button"
  tabindex="0"
  aria-label="Close schedule modal"
  (click)="closeScheduleModal()"
  (keydown.escape)="closeScheduleModal()"
>
  <div
    class="modal"
    role="dialog"
    aria-modal="true"
    (click)="$event.stopPropagation()"
    (keydown)="$event.stopPropagation()"
  >
    <h3>
      {{ editingSchedule ? 'Edit Cron Schedule' : 'Add Cron Schedule' }}
    </h3>

    <!-- Cron -->
    <label for="scheduleCronName"> Cron Type </label>

    <select id="scheduleCronName" class="form-select" [(ngModel)]="scheduleForm.cronName">
      <option *ngFor="let c of availableCrons" [value]="c">
        {{ getCronLabel(c) }}
      </option>
    </select>

    <!-- Frequency -->
    <label class="mt-3"> Frequency </label>

    <select class="form-select" [(ngModel)]="scheduleForm.scheduleType">
      <option value="once">Once</option>
      <option value="daily">Daily</option>
      <!-- <option value="weekly">Weekly</option>
      <option value="monthly">Monthly</option>
      <option value="annually">Annually</option>
      <option value="custom">Custom</option> -->
    </select>

    <!-- Time -->
    <div *ngIf="scheduleForm.scheduleType !== 'once'" class="mt-3">
      <label> Run Time </label>

      <input type="time" class="form-control" [(ngModel)]="scheduleForm.runTime" />
    </div>

    <div *ngIf="scheduleForm.scheduleType === 'once'">
      <label>Run Date & Time</label>

      <input type="datetime-local" class="form-control" [(ngModel)]="scheduleForm.runAt" />
    </div>

    <div *ngIf="scheduleForm.scheduleType === 'weekly'" class="mt-3">
      <label> Day </label>

      <select class="form-select" [(ngModel)]="selectedWeekDay">
        <option *ngFor="let day of weekDays" [ngValue]="day.value">
          {{ day.label }}
        </option>
      </select>
    </div>

    <div *ngIf="scheduleForm.scheduleType === 'monthly'" class="mt-3">
      <label> Day of Month </label>

      <select class="form-select" [(ngModel)]="selectedMonthDay">
        <option *ngFor="let day of monthDays" [ngValue]="day">
          {{ day }}
        </option>
      </select>
    </div>

    <div *ngIf="scheduleForm.scheduleType === 'annually'" class="mt-3">
      <div class="row">
        <div class="col-md-6">
          <label> Month </label>

          <select class="form-select" [(ngModel)]="selectedMonth">
            <option *ngFor="let month of months" [ngValue]="month.value">
              {{ month.label }}
            </option>
          </select>
        </div>

        <div class="col-md-6">
          <label> Day </label>

          <select class="form-select" [(ngModel)]="selectedAnnualDay">
            <option *ngFor="let day of monthDays" [ngValue]="day">
              {{ day }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div *ngIf="scheduleForm.scheduleType === 'custom'" class="mt-3">
      <label> Cron Expression </label>

      <input
        type="text"
        class="form-control"
        placeholder="e.g. 0 */30 * * *"
        [(ngModel)]="scheduleForm.cronExpression"
      />

      <small class="text-muted"> Example: 0 */30 * * * = Every 30 minutes </small>
    </div>

    <label class="mt-3"> Timezone </label>

    <select class="form-select" [(ngModel)]="scheduleForm.timezone">
      <option *ngFor="let timezone of timezones" [value]="timezone">
        {{ timezone }}
      </option>
    </select>

    <!-- Business -->
    <ng-container *ngIf="!editingSchedule">
      <label class="mt-3"> Business </label>

      <!-- <select class="form-select" [(ngModel)]="scheduleForm.businessId">
      <option value="">All Businesses</option>

      <option *ngFor="let business of businesses" [value]="business.id">
        {{ business.name }}
      </option>
    </select> -->
      <ng-select
        class="me-3"
        [items]="businesses$ | async"
        bindValue="id"
        placeholder="Select Business Entity"
        [searchable]="true"
        [clearable]="true"
        [searchFn]="customSearchFn"
        [(ngModel)]="scheduleForm.businessId"
      >
        <ng-template ng-label-tmp let-item="item">
          {{ item.businessName | capitalize }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          {{ item.businessName | capitalize }}
        </ng-template>
      </ng-select>
    </ng-container>
    <!-- Enable -->
    <!-- <div class="form-check mt-3 d-flex align-items-center">
      <input
        type="checkbox"
        id="scheduleEnabled"
        class="form-check-input schedule-checkbox"
        [(ngModel)]="scheduleForm.enabled"
      />

      <label class="form-check-label ms-2 mb-0" for="scheduleEnabled"> Enable this schedule </label>
    </div> -->

    <p class="error-text" *ngIf="scheduleError">
      {{ scheduleError }}
    </p>

    <div class="modal-actions">
      <button type="button" class="btn btn-light" (click)="closeScheduleModal()">Cancel</button>

      <button
        type="button"
        class="btn btn-primary"
        [disabled]="scheduleSubmitting"
        (click)="saveSchedule()"
      >
        {{ scheduleSubmitting ? 'Saving...' : 'Save Schedule' }}
      </button>
    </div>
  </div>
</div>

<!-- cron schedule modal end -->
